<input [formControl]="control" [attr.data-testid]="'gosu-validator-input'" />
@if (control.errors) {
  <span
    class="error"
    [style.left.px]="offsetX"
    [style.top.px]="offsetY"
    [attr.data-testid]="'gosu-validator-error-message'"
    >
    {{ getErrorMessage() }}
  </span>
}
